import { render } from "./FocusSimp.vue?vue&type=template&id=39559388"
import script from "./FocusSimp.vue?vue&type=script&lang=js"
export * from "./FocusSimp.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__